export const editFormStatus = (status, form) => {
	form.classList.add( status );
	form.classList.remove( 'sending' );
	form.classList.add( 'sent' );
	form.querySelectorAll( 'ul.fields > li' ).forEach( ( item ) => item.classList.remove( 'not-empty' ));
};
